import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";

import { GET_INTENT_PROJECT } from "./gql";

const useIntentProject = () => {
  const { intentProjectId } = useParams<{ intentProjectId: string }>();

  const { data, loading, error } = useQuery(GET_INTENT_PROJECT, {
    variables: { id: intentProjectId || "" },
    skip: !intentProjectId,
  });

  return {
    intentProject: data?.intentProject,
    loading,
    error,
  };
};

export default useIntentProject;
